import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { BellRing, Trash2 } from 'lucide-react';

// Stage 2 · Reminds the operator to delete leftover drafts once a quote has been sent.
export function DraftsReminderBanner({ api, appraisalId }) {
  const [info, setInfo] = useState(null);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/appraisals/${appraisalId}/builder-drafts`);
      setInfo(data);
    } catch { setInfo(null); }
  }, [api, appraisalId]);
  useEffect(() => { load(); }, [load]);

  if (!info?.show_reminder) return null;
  const remove = async (id) => {
    if (!window.confirm('Delete this leftover draft?')) return;
    try { await api.delete(`/appraisals/${id}/draft`); toast.success('Draft deleted'); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Delete failed'); }
  };
  return (
    <div className="rounded-md border-2 border-amber-300 bg-amber-50 px-4 py-3 space-y-2" data-testid="drafts-reminder-banner">
      <div className="flex items-center gap-2 text-sm text-amber-900 font-semibold">
        <BellRing className="w-4 h-4" /> Quote sent · {info.drafts.length} leftover draft{info.drafts.length > 1 ? 's' : ''} to delete
      </div>
      <div className="flex flex-wrap gap-2">
        {info.drafts.map(d => (
          <span key={d.id} className="inline-flex items-center gap-2 text-xs bg-white border border-amber-300 rounded px-2 py-1" data-testid={`drafts-reminder-item-${d.id}`}>
            {d.variant_label}
            <button onClick={() => remove(d.id)} className="text-rose-700 hover:text-rose-900 transition-colors" data-testid={`drafts-reminder-delete-${d.id}`}>
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}
